import { render, staticRenderFns } from "./SiteFooter.vue?vue&type=template&id=24f49ff8"
var script = {}
import style0 from "./SiteFooter.vue?vue&type=style&index=0&id=24f49ff8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports